import { Column } from "@ant-design/plots";
import React, { Fragment } from "react";
import { Col } from "reactstrap";
import HeaderCard from "../Common/Component/HeaderCard";

const GroupedColumnPlot = ({ title, data, label_color = "#fff" }) => {
  // const data = [
  //   {
  //     name: "Budget",
  //     category: "Tiles",
  //     value: 150000,
  //   },
  //   {
  //     name: "Actual",
  //     category: "Tiles",
  //     value: 120000,
  //   },
  //   {
  //     name: "Budget",
  //     category: "Laminates",
  //     value: 190000,
  //   },
  //   {
  //     name: "Actual",
  //     category: "Laminates",
  //     value: 110000,
  //   },
  //   {
  //     name: "Budget",
  //     category: "Marbles",
  //     value: 150000,
  //   },
  //   {
  //     name: "Actual",
  //     category: "Marbles",
  //     value: 160000,
  //   },
  //   {
  //     name: "Budget",
  //     category: "Doors",
  //     value: 150000,
  //   },
  //   {
  //     name: "Actual",
  //     category: "Doors",
  //     value: 160000,
  //   },
  //   {
  //     name: "Budget",
  //     category: "Ceiling",
  //     value: 150000,
  //   },
  //   {
  //     name: "Actual",
  //     category: "Ceiling",
  //     value: 160000,
  //   },
  // ];

  const config = {
    data: data.map(item => {
      return {
        ...item,
        value: parseFloat(Number(item.value).toFixed(0)),
      }
    }) ?? [],
    isGroup: true,
    xField: "category",
    yField: "value",
    seriesField: "name",
    yAxis: {
      label: {
        style: {
          fill: 'grey',
          lineWidth: 6,
          lineDash: [4, 5],
          strokeOpacity: 0.7,
          cursor: 'pointer',
          offsetX:5,
          type:'inner',
          position:'top',
          fontSize: 13,
          paddingLeft:10,
          fontWeight:500,
          marginLeft:10,
        }
      }
    },
    label: {
      style: {
        fill: label_color,
      },
      // 可手动配置 label 数据标签位置
      position: "middle",
      // 'top', 'middle', 'bottom'
      // 可配置附加的布局方法
      layout: [
        // 柱形图数据标签位置自动调整
        {
          type: "interval-adjust-position",
        }, // 数据标签防遮挡
        {
          type: "interval-hide-overlap",
        }, // 数据标签文颜色自动调整
        {
          type: "adjust-color",
        },
      ],
    },
  };
  return (
    <Fragment>
      <Col>
        {/* <Card> */}
        <HeaderCard title={title} />
        <Column style={{ padding: "1rem" }} {...config} height={300} />
        {/* </Card> */}
      </Col>
    </Fragment>
  );
};

export default GroupedColumnPlot;
